import { z } from 'zod';

import { TSDStatus, TSDType } from '@e-origin/shared';

import { TSDConsignmentSchema } from './TSDConsignmentSchema';
import { TSDCustomsStateSchema } from './TSDCustomsStateSchema';
import { TSDGeneralInfoSchema } from './TSDGeneralInfoSchema';
import { TSDViewPNDataSchema, TSDViewPNGeneralInfoSchema } from './TSDViewPNDataSchema';

export const TSDSchema = TSDGeneralInfoSchema.merge(TSDViewPNDataSchema).merge(
  z.object({
    _id: z.any(),
    name: z.string().min(1, { message: 'Required' }),
    useCustomsSimulator: z.boolean().optional(),
    generalInfo: TSDGeneralInfoSchema.shape.generalInfo
      .merge(TSDViewPNGeneralInfoSchema)
      .merge(
        z.object({
          status: z.nativeEnum(TSDStatus).optional().nullable(),
          type: z.nativeEnum(TSDType).optional().nullable(),
          isAmended: z.boolean().optional().nullable(),
          isDeconsolidated: z.boolean().optional().nullable(),
          isDeconsolidatedRejected: z.boolean().optional().nullable(),
        }),
      )
      .optional(),
    declarant: z.any().optional().nullable(),
    createdBy: z.any().optional().nullable(),
    messageInfo: z
      .object({
        LRN: z.string().optional().nullable(),
        CRN: z.string().optional().nullable(),
        MRN: z.string().optional().nullable(),
        FRN: z.string().optional().nullable(),
      })
      .optional(),
    consignment: TSDConsignmentSchema.optional(),
    customsState: TSDCustomsStateSchema.optional(),
  }),
);
export type TSDData = z.infer<typeof TSDSchema>;
